import Vue from 'vue'
import Vuex from 'vuex'
import operators from './modules/operators'
import products from './modules/products'
import overviews from './modules/overviews'
import publications from './modules/publications';
import itemgroups from './modules/itemgroups';
import sideorders from './modules/sideorders';
import tabs from './modules/tabs';
import queuegroups from './modules/queuegroups';
import deleteditems from './modules/deleteditems';
import payments from './modules/payments';
import barviewregistrations from './modules/barviewregistrations';
import barviewaccess from './modules/barviewaccess';
import zreports from './modules/zreports';
import messages from './modules/messages';
import categories from './modules/categories';
import audits from './modules/audits';
import giftcards from './modules/giftcards';
import invoices from './modules/invoices';
import productoptions from './modules/productoptions';
import discounts from './modules/discounts';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    metaData: window.metaData != 'META_DATA_PLACEHOLDER' ? window.metaData : {
      'version': require('../../package.json').version + '-SNAPSHOT'
    }
  },
  modules: {
    operators,
    products,
    publications,
    overviews,
    itemgroups,
    sideorders,
    tabs,
    queuegroups,
    deleteditems,
    payments,
    barviewregistrations,
    barviewaccess,
    zreports,
    messages,
    categories,
    audits,
    giftcards,
    invoices,
    productoptions,
    discounts
  }
});
